/** System-level shell state for refresh notifications and fatal server errors. */
export interface SystemState {
    /** Controls whether the refresh modal is currently visible. */
    refreshModalVisible: boolean;
    /** Indicates that the shell should show the fatal error fallback. */
    serverError: boolean;
}

/**
 * Default system state used when the shell store is initialized.
 *
 * @returns Default system state snapshot.
 */
export const initialSystemState: SystemState = {
    refreshModalVisible: false,
    serverError: false,
};
